import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import { DataCenterPrefix, DsLoggingService, LocalStorageKey, ShutdownReason } from '@cubigo/digital-signage';

import { filter, take, timer } from 'rxjs';

import { AuthService } from 'app/shared/services';
import { DisplayHealthService } from 'app/shared/services/display-health.service';
import { ServiceWorkerUpdaterService } from 'app/shared/services/service-worker-updater.service';

import appVersion from '../../package.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly displayHealth = inject(DisplayHealthService);
  private readonly logging = inject(DsLoggingService);
  private readonly serviceWorkerUpdater = inject(ServiceWorkerUpdaterService);

  public ngOnInit(): void {
    const region = localStorage.getItem(LocalStorageKey.DataCenterPrefix) ?? DataCenterPrefix.Unknown;
    this.logging.appVersion = appVersion.version;
    this.logging.setInstrumentationKeyOnRegion(region);
    this.logging.beginSession();
    this.authService.initialize();
    this.displayHealth.start();
    this.serviceWorkerUpdater.init();
    this.scheduleReload();
  }

  private scheduleReload(): void {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    const delay = midnight.getTime() - Date.now() + Math.random() * 2 * 60 * 60 * 1000;
    timer(delay, 5 * 60 * 1000).pipe(
      filter(() => navigator.onLine),
      take(1),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.logging.markCleanShutdown(ShutdownReason.NightlyReload);
      this.reload();
    });
  }

  private reload(): void {
    window.location.reload();
  }
}
